"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.discountApplicationApplies = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const semantic_ui_react_1 = require("semantic-ui-react");
const MoneyV2_1 = __importDefault(require("../shared/storefront/MoneyV2"));
require("./DiscountApplicationIndicator.css");
(0, client_1.gql) `
  fragment StorefrontDiscountApplication on StorefrontDiscountApplication {
    targetSelection
    targetType
    allocationMethod
    value {
      ... on StorefrontMoneyV2 {
        amount
        currencyCode
      }
      ... on StorefrontPricingPercentageValue {
        percentage
      }
    }
    ... on StorefrontAutomaticDiscountApplication {
      title
    }
    ... on StorefrontDiscountCodeApplication {
      code
      applicable
    }
  }
`;
function discountApplicationApplies(discountApplication) {
    const typename = discountApplication.__typename;
    switch (typename) {
        case "StorefrontDiscountCodeApplication":
            return discountApplication.applicable;
        default:
            return true;
    }
}
exports.discountApplicationApplies = discountApplicationApplies;
function DiscountApplicationIndicator({ discountApplication, }) {
    if (!discountApplicationApplies(discountApplication)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "discount-application-indicator" }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "label" }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "tag" }), (0, jsx_runtime_1.jsx)(DiscountApplicationText, { discountApplication: discountApplication }), " ", (0, jsx_runtime_1.jsx)(PricingValueText, { pricingValue: discountApplication.value })] })) })));
}
exports.default = DiscountApplicationIndicator;
function PricingValueText({ pricingValue }) {
    //@ts-ignore
    const typename = pricingValue.__typename;
    switch (typename) {
        case "MoneyV2":
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MoneyV2_1.default, { moneyV2: pricingValue }), " off"] }));
        case "PricingPercentageValue":
            const percentageValue = pricingValue;
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [percentageValue.percentage, "% off"] });
        default:
            return null;
    }
}
function DiscountApplicationText({ discountApplication, }) {
    const typename = discountApplication.__typename;
    switch (typename) {
        case "StorefrontAutomaticDiscountApplication":
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: discountApplication
                    .title }));
        case "StorefrontDiscountCodeApplication":
            const discountCode = discountApplication;
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: discountCode.code });
        case "StorefrontManualDiscountApplication":
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Manual Discount" });
        case "StorefrontScriptDiscountApplication":
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Automatic Discount" });
        default:
            return null;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY291bnRBcHBsaWNhdGlvbkluZGljYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NhcnQvRGlzY291bnRBcHBsaWNhdGlvbkluZGljYXRvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLDJDQUFxQztBQUNyQyx5REFBeUM7QUFTekMsMkVBQW1EO0FBQ25ELDhDQUE0QztBQUU1QyxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQXNCRixDQUFDO0FBTUYsU0FBZ0IsMEJBQTBCLENBQ3hDLG1CQUEwRDtJQUUxRCxNQUFNLFFBQVEsR0FBRyxtQkFBbUIsQ0FBQyxVQUFVLENBQUM7SUFDaEQsUUFBUSxRQUFRLEVBQUU7UUFDaEIsS0FBSyxtQ0FBbUM7WUFDdEMsT0FBTyxtQkFBbUIsQ0FBQyxVQUFVLENBQUM7UUFDeEM7WUFDRSxPQUFPLElBQUksQ0FBQztLQUNmO0FBQ0gsQ0FBQztBQVZELGdFQVVDO0FBRUQsU0FBd0IsNEJBQTRCLENBQUMsRUFDbkQsbUJBQW1CLEdBQ2dCO0lBQ25DLElBQUksQ0FBQywwQkFBMEIsQ0FBQyxtQkFBbUIsQ0FBQyxFQUFFO1FBQ3BELE9BQU8sSUFBSSxDQUFDO0tBQ2I7SUFDRCxPQUFPLENBQ0wsK0NBQU0sU0FBUyxFQUFDLGdDQUFnQyxnQkFDOUMsZ0RBQU0sU0FBUyxFQUFDLE9BQU8saUJBQ3JCLHVCQUFDLHdCQUFJLElBQUMsSUFBSSxFQUFDLEtBQUssR0FBRyxFQUNuQix1QkFBQyx1QkFBdUIsSUFDdEIsbUJBQW1CLEVBQUUsbUJBQW1CLEdBQ3hDLEVBQUMsR0FBRyxFQUNOLHVCQUFDLGdCQUFnQixJQUFDLFlBQVksRUFBRSxtQkFBbUIsQ0FBQyxLQUFLLEdBQUksS0FDeEQsSUFDRixDQUNSLENBQUM7QUFDSixDQUFDO0FBakJELCtDQWlCQztBQU1ELFNBQVMsZ0JBQWdCLENBQUMsRUFBRSxZQUFZLEVBQTBCO0lBQ2hFLFlBQVk7SUFDWixNQUFNLFFBQVEsR0FBRyxZQUFZLENBQUMsVUFBMkMsQ0FBQztJQUMxRSxRQUFRLFFBQVEsRUFBRTtRQUNoQixLQUFLLFNBQVM7WUFDWixPQUFPLENBQ0wsNkRBQ0UsdUJBQUMsaUJBQU8sSUFBQyxPQUFPLEVBQUUsWUFBaUMsR0FBSSxZQUN0RCxDQUNKLENBQUM7UUFDSixLQUFLLHdCQUF3QjtZQUMzQixNQUFNLGVBQWUsR0FBRyxZQUFnRCxDQUFDO1lBQ3pFLE9BQU8sNkRBQUcsZUFBZSxDQUFDLFVBQVUsYUFBUyxDQUFDO1FBQ2hEO1lBQ0UsT0FBTyxJQUFJLENBQUM7S0FDZjtBQUNILENBQUM7QUFNRCxTQUFTLHVCQUF1QixDQUFDLEVBQy9CLG1CQUFtQixHQUNXO0lBQzlCLE1BQU0sUUFBUSxHQUFHLG1CQUFtQixDQUFDLFVBQVUsQ0FBQztJQUNoRCxRQUFRLFFBQVEsRUFBRTtRQUNoQixLQUFLLHdDQUF3QztZQUMzQyxPQUFPLENBQ0wsMkRBRUssbUJBQThEO3FCQUM1RCxLQUFLLEdBRVQsQ0FDSixDQUFDO1FBQ0osS0FBSyxtQ0FBbUM7WUFDdEMsTUFBTSxZQUFZLEdBQUcsbUJBQXdELENBQUM7WUFDOUUsT0FBTywyREFBRyxZQUFZLENBQUMsSUFBSSxHQUFJLENBQUM7UUFDbEMsS0FBSyxxQ0FBcUM7WUFDeEMsT0FBTywrRUFBb0IsQ0FBQztRQUM5QixLQUFLLHFDQUFxQztZQUN4QyxPQUFPLGtGQUF1QixDQUFDO1FBQ2pDO1lBQ0UsT0FBTyxJQUFJLENBQUM7S0FDZjtBQUNILENBQUMifQ==